import { CatchAPIService, MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class ClassificationService {
  DoGetClassificationList() {
    const _input = {
      merchantId: MerchantId(),
      isUseMainDatabase: true,
    };
    return service.peakExportAPI
      .post("/api/Allocation/GetAllocationList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetClassificationItemList(classificationId: number) {
    const _input = {
      merchantId: MerchantId(),
      allocationId: classificationId,
      isUseMainDatabase: true,
    };
    return service.peakExportAPI
      .post("/api/Allocation/GetAllocationItemList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
}

export default new ClassificationService();
